export const AT_LEAST_ONE_ALPHABET = /^(?=.*[a-zA-Z])(?!^\d+$)(?!^[^\w\s]+$).+/;

export const NOT_ALLOWED_SPECIAL_CHARS = /^[a-zA-Z0-9 _\-&]*$/;

export const ONLY_NUMBERS = /^\d+$/;

export const NO_WHITESPACE_ALLOWED = /^\S+$/;

export const OBJECT_IDENTIFIER_REGEX = /^[A-Za-z][A-Za-z0-9_]{0,254}$/;

export const S3_FOLDER_PATH_PATTERN = '^(?!/)(?!.*//)[a-zA-Z0-9._/-]+/?$';

export const ALPHA_START_ALNUM_REGEX = /^[A-Za-z][A-Za-z0-9]*$/;

export const VALID_EMAIL_PATTERN_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const NOT_ONLY_WHITESPACE = /^(?!\s*$).+/;

export const ISO_UTC_TIMESTAMP_VALIDATOR = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
